export function assert(condition: boolean | object | string | undefined | null, message?: string): asserts condition {
  if (!condition) {
    throw new Error(message ?? 'Assertion failed');
  }
}
